import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef} from '@angular/material/legacy-dialog';
import {DossierTemplateService} from '../../../services/dossier-template/dossier-template.service';

@Component({
  selector: 'app-add-dossier-template-folder-dialog',
  templateUrl: './add-dossier-template-folder-dialog.component.html',
  styleUrls: ['./add-dossier-template-folder-dialog.component.scss']
})
export class AddDossierTemplateFolderDialogComponent implements OnInit {
  addFolderForm!: UntypedFormGroup;

  constructor(
    public formBuilder: UntypedFormBuilder,
    public templateService: DossierTemplateService,
    public dialogRef: MatDialogRef<AddDossierTemplateFolderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit(): void {
    this.addFolderForm = this.formBuilder.group({
      name: [null, [Validators.required]],
      signable: [false, [Validators.required]],
      description: ['', []],
      fileRequests: new UntypedFormArray([]),
    });
    this.newFilerequest();
  }

  get f() { return this.addFolderForm.controls; }
  get t() { return this.f.fileRequests as UntypedFormArray; }

  newFilerequest() {
    this.t.push(this.formBuilder.group({
      filename: [null, [Validators.required]],
      description: [null, []],
    }));
  }

  closeModal() {
    this.dialogRef.close(false);
  }

  deleteRequest(i: number) {
    this.t.removeAt(i);
  }

  async addFolder() {
    this.addFolderForm.markAllAsTouched();

    for (const form of this.t.controls) {
      if (form.invalid) {
        form.markAllAsTouched();
      }
    }

    if (this.addFolderForm.invalid){
      return;
    }

    try {
      const result = await this.templateService.createFolder(this.data.template.id, {
        name: this.addFolderForm.get('name')?.value,
        isFinalFolder: this.addFolderForm.get('signable')?.value,
        description: this.addFolderForm.get('description')?.value || ''
      });

      const createdFileRequests = [];

      for (const request of this.addFolderForm.value.fileRequests) {
        if (request.filename) {
          createdFileRequests.push(await this.templateService.createRequest(this.data.template.id, {
            filename: request.filename,
            folderTemplateId: result.id,
            message: request.description || ''
          }));
        }
      }
      this.dialogRef.close(
        {folder: result, fileRequests: createdFileRequests});
    } catch (e){
      console.error(e);
    }
  }
}
